import Vue from 'vue';

const QuillEvents = {
  EDIT: 'EDIT',
  REMOVE: 'REMOVE',
  CREATE: 'CREATE',
  SEARCH_REPLACE: 'SEARCH_REPLACE',
  BLOT_SELECTED: 'BLOT_SELECTED',
  DROPDOWN: 'DROPDOWN',
  FULLSCREEN: 'FULLSCREEN',
  SPELLING_CHECK: 'SPELLING_CHECK',
};
const QuillEventBus = new Vue();

export { QuillEventBus as default, QuillEvents };
